import AuthStore from 'stores/authStore'
import CollectionStore from 'stores/collectionStore'
import OrganizationStore from 'stores/organizationStore'
import ProcessStore from 'stores/processStore'
import UserStore from 'stores/userStore'
import CommonLibraryStore from './commonLibraryStore'
import DocumentTypeStore from './documentTypeStore'
import EcnSuggestionStore from './ecnSuggestionStore'
import FavoriteStore from './favoriteStore'
import GeneralStore from './generalStore'
import GroupStore from './groupStore'
import IconBuilderStore from './iconBuilderStore'
import MessageStore from './messageStore'
import NotificationStore from './notificationStore'
import ReportStore from './reportStore'
import SearchStore from './searchStore'
import SpinnerStore from './spinnerStore'
import StepStore from './stepStore'
import TagStore from './tagStore'
import ThemeStore from './themeStore'
import SsoConfigStore from './ssoConfig.store'
import PlanStore from './planStore'
import UserWorkplanStore from './userWorkplanStore'

export class RootStore {
  spinnerStore: SpinnerStore
  commonLibraryStore: CommonLibraryStore
  authStore: AuthStore
  organizationStore: OrganizationStore
  userStore: UserStore
  processStore: ProcessStore
  favoriteStore: FavoriteStore
  searchStore: SearchStore
  collectionStore: CollectionStore
  stepStore: StepStore
  notificationStore: NotificationStore
  groupStore: GroupStore
  messageStore: MessageStore
  documentTypeStore: DocumentTypeStore
  tagStore: TagStore
  iconBuilderStore: IconBuilderStore
  ecnSuggestionStore: EcnSuggestionStore
  themeStore: ThemeStore
  reportStore: ReportStore
  generalStore: GeneralStore
  ssoConfigStore: SsoConfigStore
  planStore: PlanStore
  userWorkplanStore: UserWorkplanStore

  constructor() {
    this.spinnerStore = new SpinnerStore(this)
    this.commonLibraryStore = new CommonLibraryStore(this)
    this.authStore = new AuthStore(this)
    this.organizationStore = new OrganizationStore(this)
    this.userStore = new UserStore(this)
    this.processStore = new ProcessStore(this)
    this.favoriteStore = new FavoriteStore(this)
    this.searchStore = new SearchStore(this)
    this.collectionStore = new CollectionStore(this)
    this.stepStore = new StepStore(this)
    this.notificationStore = new NotificationStore(this)
    this.groupStore = new GroupStore(this)
    this.messageStore = new MessageStore(this)
    this.documentTypeStore = new DocumentTypeStore(this)
    this.tagStore = new TagStore(this)
    this.iconBuilderStore = new IconBuilderStore(this)
    this.ecnSuggestionStore = new EcnSuggestionStore(this)
    this.themeStore = new ThemeStore(this)
    this.reportStore = new ReportStore(this)
    this.generalStore = new GeneralStore(this)
    this.ssoConfigStore = new SsoConfigStore(this)
    this.planStore = new PlanStore(this)
    this.userWorkplanStore = new UserWorkplanStore(this)
  }
}

export const rootStore = new RootStore()
